import FetchApi from "../util/fetchApi";
const fetchApi = new FetchApi();

export default class AuditService {
  async getAuditReport(postData) {
    let { search, limit, page, orderBy, order, eventTypes, startDate, endDate, selectedWorkspaces } = postData;

    return (
      await fetchApi.get(
        `/audit/list?limit=${limit}&startDate=${startDate}&endDate=${endDate}&page=${page}&orderBy=${orderBy}&order=${order}&eventTypes=${eventTypes}&workspaces=${selectedWorkspaces}${
          search ? `&search=${encodeURIComponent(search)}` : `&search=${encodeURIComponent("")}`
        }`
      )
    ).data;
  }

  async getEventDetails(eventid) {
    return (await fetchApi.get(`/audit/details/${eventid}`)).data;
  }

  async getAuditWorkspaces() {
    return (await fetchApi.get(`/audit/workspaces`)).data;
  }
}
